// 话题评论列表分页查询
const getTopicCommentList = "gateway/hc-neighbour/topic/getTopicCommentList"; // 进行评论
const addCommentURL = "gateway/hc-neighbour/topic/addComment";
// 点赞
const addPraiseURL = `gateway/hc-neighbour/topic/addPraise`;
// 取消点赞
const cancelPraiseURL = `gateway/hc-neighbour/topic/cancelPraise`;
export { getTopicCommentList, addCommentURL, addPraiseURL, cancelPraiseURL };
